import * as stylex from '@stylexjs/stylex';
import { Link } from 'react-router-dom';
import { EditableText } from '@/core/EditableText.atom';
import { AUTO_WIDTH_OFFSET } from '@/main/app.constants';
import { getWorksheetLink } from '@/main/routing.utilities';
import { useUpdateTreeName } from '@/treeBuilder/useUpdateTreeName.hook';

export interface TreeBuilderHeaderProps {
  tableId: string;
  name: string;
  tableScopedTo?: string;
  workbookId?: string;
  workbookName?: string;
  canWrite?: boolean;
}

export const TreeBuilderHeader = ({
  tableId,
  name,
  tableScopedTo,
  workbookId,
  workbookName,
  canWrite = true,
}: TreeBuilderHeaderProps) => {
  const { updateTreeName } = useUpdateTreeName();

  return (
    <div {...stylex.props(styles.root)}>
      {workbookId && (workbookId === tableScopedTo || !tableId) && workbookName && (
        <div {...stylex.props(styles.breadcrumbContainer)}>
          <span {...stylex.props(styles.breadcrumbText)}>
            <ul {...stylex.props(styles.breadcrumbs)}>
              <li {...stylex.props(styles.breadcrumb)} key="crumbId_workbook">
                <Link to={getWorksheetLink(workbookId)} {...stylex.props(styles.breadcrumbLink)}>
                  {workbookName}
                </Link>
              </li>
            </ul>
          </span>
        </div>
      )}
      <EditableText
        onUpdate={(newName) => updateTreeName(tableId, newName)}
        value={name}
        textClasses={stylex.props(styles.name).className}
        testId="headerItemTableName"
        id="headerItemTableName"
        offsetWidth={AUTO_WIDTH_OFFSET}
        oneLineText={true}
        allowEditing={canWrite}
      />
    </div>
  );
};

const styles = stylex.create({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  breadcrumbContainer: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: 0,
    flex: '0 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  breadcrumbText: {
    fontSize: '11px',
    marginTop: '0rem',
    marginBottom: '0.125rem',
  },
  breadcrumbs: {
    paddingLeft: 0,
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'row',
    whiteSpace: 'nowrap',
    marginTop: '0rem',
    marginBottom: '0rem',
    flex: '0 1 auto',
    fontWeight: 400,
  },
  breadcrumbLink: { color: '#fff' },
  breadcrumb: {
    'maxWidth': '7.8125rem',
    'overflow': 'hidden',
    'textOverflow': 'ellipsis',
    'cursor': 'pointer',
    'color': '#fff',
    '::before': { content: "''", marginRight: 2 },
    'marginLeft': '0.125rem',
  },
  name: {
    fontSize: '14px',
    minWidth: '1.25rem',
  },
});
